import { BoxProps, VStack } from '@chakra-ui/react';

const Container = (props: BoxProps) => (
  <VStack
    px={{
      base: 12,
      '2xl': 36,
    }}
    justifyContent="center"
    {...props}
  />
);

export default Container;
